'use strict';

angular.module('app.error')
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('error', {
            templateUrl: 'html/error.html',
            controller: 'ErrorController',
            controllerAs: 'error',
            params: {
                type: {
                    type: 'string',
                    value: 'generic',
                },
                code: {
                    type: 'string',
                    value: 'generic',
                },
            },
        });

        $stateProvider.state('not-found', {
            name: 'not-found',
            url: '*path',
            onEnter: ['$state', function($state) {
                $state.go('error', {
                    code: 'not-found',
                });
            }],
        });
    }]);
